/*
  Esc Lef Dwn Upp Rgt Bck  <- navigation row
  1 2 3 4 5 6 7 8 9 0 - =  <- num row
  q w e r t y u i o p [ ]  <- top
  ` a s d f g h j k l ; '  <- home row
  ^ z x c v b n m , . / \  <- bottom row
  Ctl Cap Spaaace Tab Ent  <- control row
*/
const DIGITS = Object.fromEntries([
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'
].map(digit => [
  digit, {
    key: digit,
    display: digit,
    alphanumeric: true,
  }
]));
const ALPHABET = Object.fromEntries([
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k' ,'l', 'm',
  'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
].map(letter => [
  letter, {
    key: letter,
    display: letter,
    alphanumeric: true,
  }
]));
const SYMBOLS = Object.fromEntries([
  '`', '~', ',', '<', '.', '>', '/', '?', ';', ':', '\'', '"',
  '[', '{', ']', '}', '\\', '|', '-', '_', '=', '+', '!', '@',
  '#', '$', '%', '^', '&', '*', '(', ')'
].map(symbol => [
  symbol, {
    key: symbol,
    display: symbol,
  }
]));
const ARROWS = Object.fromEntries(Object.entries({
  ArrowLeft: '\u25C0', ArrowDown: '\u25BC',
  ArrowUp: '\u25B2', ArrowRight: '\u25B6'
}).map(([key, value]) => [
  key, {
    key,
    display: value,
  }
]));
const KEYS = {
  Backspace: { key: 'Backspace', display: '\u2190' },
  Escape: { key: 'Escape', display: 'esc' },
  Enter: { key: 'Enter', display: '\u23CE' },
  Shift: { key: 'Shift', display: 'shf', sticky: true },
  Control: { key: 'Control', display: 'ctl', sticky: true },
  CapsLock: { key: 'CapsLock', display: '\u21EA', sticky: true },
  Tab: { key: 'Tab', display: '\u21E5' },
  Space: { key: ' ', display: '\u21B7' },
  Ball: { key: null, display: '\u25CB' },
  ...ALPHABET,
  ...ARROWS,
  ...DIGITS,
  ...SYMBOLS,
};
const CODES = Object.fromEntries(Object.entries({
  ArrowLeft: [KEYS.ArrowLeft],
  ArrowRight: [KEYS.ArrowRight],
  ArrowDown: [KEYS.ArrowDown],
  ArrowUp: [KEYS.ArrowUp],
  Backquote: [KEYS['`'], KEYS['~']],
  Backslash: [KEYS['\\'], KEYS['|']],
  Backspace: [KEYS.Backspace],
  Ball: [KEYS.Ball],
  BracketLeft: [KEYS['['], KEYS['{']],
  BracketRight: [KEYS[']'], KEYS['}']],
  CapsLock: [KEYS.CapsLock],
  Comma: [KEYS[','], KEYS['>']],
  Enter: [KEYS.Enter],
  Equal: [KEYS['='], KEYS['+']],
  Escape: [KEYS.Escape],
  Digit1: [KEYS[1], KEYS['!']],
  Digit2: [KEYS[2], KEYS['@']],
  Digit3: [KEYS[3], KEYS['#']],
  Digit4: [KEYS[4], KEYS['$']],
  Digit5: [KEYS[5], KEYS['%']],
  Digit6: [KEYS[6], KEYS['^']],
  Digit7: [KEYS[7], KEYS['&']],
  Digit8: [KEYS[8], KEYS['*']],
  Digit9: [KEYS[9], KEYS['(']],
  Digit0: [KEYS[0], KEYS[')']],
  Minus: [KEYS['-'], KEYS['_']],
  KeyA: [KEYS.a, KEYS.A, KEYS.A],
  KeyB: [KEYS.b, KEYS.B, KEYS.B],
  KeyC: [KEYS.c, KEYS.C, KEYS.C],
  KeyD: [KEYS.d, KEYS.D, KEYS.D],
  KeyE: [KEYS.e, KEYS.E, KEYS.E],
  KeyF: [KEYS.f, KEYS.F, KEYS.F],
  KeyG: [KEYS.g, KEYS.G, KEYS.G],
  KeyH: [KEYS.h, KEYS.H, KEYS.H],
  KeyI: [KEYS.i, KEYS.I, KEYS.I],
  KeyJ: [KEYS.j, KEYS.J, KEYS.J],
  KeyK: [KEYS.k, KEYS.K, KEYS.K],
  KeyL: [KEYS.l, KEYS.L, KEYS.L],
  KeyM: [KEYS.m, KEYS.M, KEYS.M],
  KeyN: [KEYS.n, KEYS.N, KEYS.N],
  KeyO: [KEYS.o, KEYS.O, KEYS.O],
  KeyP: [KEYS.p, KEYS.P, KEYS.P],
  KeyQ: [KEYS.q, KEYS.Q, KEYS.Q],
  KeyR: [KEYS.r, KEYS.R, KEYS.R],
  KeyS: [KEYS.s, KEYS.S, KEYS.S],
  KeyT: [KEYS.t, KEYS.T, KEYS.T],
  KeyU: [KEYS.u, KEYS.U, KEYS.U],
  KeyV: [KEYS.v, KEYS.V, KEYS.V],
  KeyW: [KEYS.w, KEYS.W, KEYS.W],
  KeyX: [KEYS.x, KEYS.X, KEYS.X],
  KeyY: [KEYS.y, KEYS.Y, KEYS.Y],
  KeyZ: [KEYS.z, KEYS.Z, KEYS.Z],
  Period: [KEYS['.'], KEYS['>']],
  Quote: [KEYS['\''], KEYS['"']],
  Semicolon: [KEYS[';'], KEYS[':']],
  ShiftLeft: [KEYS.Shift],
  ShiftRight: [KEYS.Shift],
  ControlLeft: [KEYS.Control],
  ControlRight: [KEYS.Control],
  Slash: [KEYS['/'], KEYS['?']],
  Space: [KEYS.Space],
  Tab: [KEYS.Tab],
}).map(([code, [initial, shift, caps]]) => ([code, {code, initial, shift, caps}])));

const LAYOUT = [
  [CODES.Escape, CODES.ArrowLeft, CODES.ArrowDown, CODES.Ball, CODES.ArrowUp, CODES.ArrowRight, CODES.Backspace],
  [CODES.Digit1, CODES.Digit2, CODES.Digit3, CODES.Digit4, CODES.Digit5, CODES.Digit6, CODES.Digit7, CODES.Digit8, CODES.Digit9, CODES.Digit0, CODES.Minus, CODES.Equal],
  [CODES.Backquote, CODES.KeyQ, CODES.KeyW, CODES.KeyE, CODES.KeyR, CODES.KeyT, CODES.KeyY, CODES.KeyU, CODES.KeyI, CODES.KeyO, CODES.KeyP, CODES.BracketLeft],
  [CODES.Quote, CODES.KeyA, CODES.KeyS, CODES.KeyD, CODES.KeyF, CODES.KeyG, CODES.KeyH, CODES.KeyJ, CODES.KeyK, CODES.KeyL, CODES.Semicolon, CODES.BracketRight],
  [CODES.CapsLock, CODES.KeyZ, CODES.KeyX, CODES.KeyC, CODES.KeyV, CODES.KeyB, CODES.KeyN, CODES.KeyM, CODES.Comma, CODES.Period, CODES.Slash, CODES.Backslash],
  [CODES.ShiftLeft, CODES.ControlLeft, CODES.Space, CODES.Tab, CODES.Enter],
];
const COMPACT_LAYOUT = [
  [CODES.KeyQ, CODES.KeyW, CODES.KeyE, CODES.KeyR, CODES.KeyT, CODES.KeyY, CODES.KeyU, CODES.KeyI, CODES.KeyO, CODES.KeyP],
  [CODES.KeyA, CODES.KeyS, CODES.KeyD, CODES.KeyF, CODES.KeyG, CODES.KeyH, CODES.KeyJ, CODES.KeyK, CODES.KeyL],
  [CODES.Space, CODES.KeyZ, CODES.KeyX, CODES.KeyC, CODES.KeyV, CODES.KeyB, CODES.KeyN, CODES.KeyM, CODES.Backspace],
];

const keyboard = {
  keys: { DIGITS, ALPHABET, SYMBOLS, ARROWS, KEYS },
  layouts: { LAYOUT, COMPACT_LAYOUT }
};

export default keyboard;
